import React from 'react';
import styled from 'styled-components';

import { GqlDispensaries } from 'types/graphql';

import useOrderType, { SimpleOrderType } from 'src/hooks/use-order-type';
import useUI from 'src/hooks/use-ui';
import useCart from 'src/hooks/use-cart';

import { ORDER_TYPE_DELIVERY, ORDER_TYPE_PICKUP } from 'shared/constants';
import { Toggle } from 'src/components/toggle/toggle';

const orderTypeOptions = [
  {
    label: 'Pickup',
    value: ORDER_TYPE_PICKUP,
  },
  {
    label: 'Delivery',
    value: ORDER_TYPE_DELIVERY,
  },
];

type OrderTypeProps = {
  dispensary: GqlDispensaries;
};

export const OrderType = ({ dispensary }: OrderTypeProps): JSX.Element | null => {
  const { isEmpty } = useCart();
  const { getOrderType, setOrderType } = useOrderType();
  const { isKiosk } = useUI();

  const currentOrderType = getOrderType();

  if (isEmpty || isKiosk) {
    return null;
  }

  const isPickupAvailable = dispensary.orderTypesConfigV2?.offerAnyPickupService;
  const isDeliveryAvailable = dispensary.orderTypesConfigV2?.offerDeliveryService;
  const hasBothOrderTypes = isPickupAvailable && isDeliveryAvailable;

  if (!hasBothOrderTypes) {
    return (
      <SingleOrderType>{orderTypeOptions.find((option) => option.value === currentOrderType)?.label}</SingleOrderType>
    );
  }

  const handleToggle = (value: string): void => {
    setOrderType(value as SimpleOrderType);
  };

  return (
    <Toggle
      data-testid='cart-header-order-type-toggle'
      label='Select order type'
      selectedOption={currentOrderType}
      options={orderTypeOptions}
      onToggle={handleToggle}
    />
  );
};

const SingleOrderType = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
`;
